<main class="content">
  <div *ngIf="car" class="d-flex flex-column gap-2">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h5>{{ 'requestedCar' | i18next }}</h5>
      <div
        class="d-flex align-items-center"
        *ngIf="
          orderInfo?.requestType === requestTypesEnum.campaigns &&
          orderInfo?.campaignDataDTO &&
          orderInfo.campaignDataDTO?.type === campaignTypesEnum.RAFFLE
        "
      >
        <button
          class="btn btn-rechazar"
          (click)="rejectVehicle()"
          [disabled]="pastDate"
        >
          {{ 'rejectVehicle' | i18next }}
        </button>
        <span class="text-time-remaining"
          >{{ 'remainingTime' | i18next }} {{ remainingHours }}h</span
        >
      </div>
    </div>
    <div class="card">
      <div class="card--image">
        <div
          class="text-center spinner-container overlay-spinner"
          *ngIf="spinnerImage"
        >
          <div class="spinner-border spinner" role="status"></div>
        </div>
        <button
          *ngIf="car.VIN && !car.image && !spinnerImage"
          class="btnContainer__btn"
          (click)="reloadImage()"
        >
          {{ 'reloadImage' | i18next }}
        </button>
        <img
          *ngIf="!spinnerImage"
          class="detail-leasing-request__img"
          [src]="
            car.VIN
              ? car.image || '../../../../assets/img/NeutroNaranjaRojo_v2.png'
              : '../../../../assets/img/NeutroNaranjaRojo_v2.png'
          "
          alt="Imagen vehículo"
        />
      </div>
      <div class="card--info">
        <div class="d-flex justify-content-between mb-2">
          <div
            class="d-flex flex-column gap-1"
            [ngStyle]="
              car.model ? { visibility: 'visible' } : { visibility: 'hidden' }
            "
          >
            <span class="text-black text-uppercase lead fw-bold">{{
              car.model
            }}</span>
          </div>
        </div>
        <div class="cardHeader d-grid gap-2 grid-container">
          <div
            class="d-flex flex-column gap-1 grid-item"
            [ngStyle]="
              car.exteriorColor
                ? { visibility: 'visible' }
                : { visibility: 'hidden' }
            "
          >
            <span class="text-black text-uppercase fw-bold">{{
              'color' | i18next
            }}</span>
            <span class="text-muted">{{ car.exteriorColor?.description }}</span>
          </div>
          <div
            class="d-flex flex-column gap-1 grid-item"
            [ngStyle]="
              car.fuelType
                ? { visibility: 'visible' }
                : { visibility: 'hidden' }
            "
          >
            <span class="text-black text-uppercase fw-bold">{{
              'combustible' | i18next
            }}</span>
            <span class="text-muted">{{
              translateFuelType(car.fuelType)
            }}</span>
          </div>
          <!-- TODO: descomentar cuando lleguen dato de potencia y consumo y quitar los datos de color y combustible de arriba
          <div class="d-flex flex-column w-100 gap-1">
            <span class="text-black text-uppercase fw-bold">{{
              'power' | i18next
            }}</span>
            <span class="text-muted"
              >{{ car.power ? car.power.hp : '-' }}CV /
              {{ car.power ? car.power.kw : '-' }}KW</span
            >
          </div>
          <div class="dd-flex flex-column w-100 gap-1">
            <span class="text-black text-uppercase fw-bold">{{
              'consumption' | i18next
            }}</span>
            <span class="text-muted">{{
              car.consumption ? car.consumption : '-'
            }}</span>
          </div> -->
          <div
            class="d-flex flex-column gap-1 grid-item"
            [ngStyle]="
              car.emissions
                ? { visibility: 'visible' }
                : { visibility: 'hidden' }
            "
          >
            <span class="text-black text-uppercase fw-bold">{{
              'estimatedEmissions' | i18next
            }}</span>
            <span class="text-muted"
              >{{ car.emissions ? car.emissions : '-' }} g/km</span
            >
          </div>
        </div>
        <hr />
        <div class="cardSubHeader d-grid gap-2 grid-container">
          <div
            class="d-flex flex-column gap-1 grid-item"
            [ngStyle]="
              car.transmission
                ? { visibility: 'visible' }
                : { visibility: 'hidden' }
            "
          >
            <span class="text-black fw-bold">{{ 'gearbox' | i18next }}</span>
            <span class="text-muted">{{
              car.transmission ? car.transmission : '-'
            }}</span>
          </div>
          <div
            class="d-flex flex-column gap-1 grid-item"
            [ngStyle]="
              car.tmaimg ? { visibility: 'visible' } : { visibility: 'hidden' }
            "
          >
            <span class="text-black fw-bold text-uppercase">{{
              'requestPccTMAIMG' | i18next
            }}</span>
            <span class="text-muted">{{ car.tmaimg }}</span>
          </div>
          <div
            class="d-flex flex-column gap-1 grid-item"
            [ngStyle]="
              car.VIN ? { visibility: 'visible' } : { visibility: 'hidden' }
            "
            *ngIf="orderInfo?.requestType !== requestTypesEnum.leasing"
          >
            <span class="text-black fw-bold">{{ 'vinNumber' | i18next }}</span>
            <span class="text-muted vinNumber">{{ car.VIN }}</span>
          </div>
          <!-- TODO: Descomentar cuando lleguen dato potencia y consumo y eliminar estos datos color de arriba
          <div class="d-flex flex-column w-100 gap-1">
            <span class="text-black fw-bold">{{
              'combustible' | i18next
            }}</span>
            <span class="text-muted">{{ car.fuelType }}</span>
          </div>
          <div class="d-flex flex-column w-100 gap-1">
            <span class="text-black fw-bold">{{ 'color' | i18next }}</span>
            <span class="text-muted">{{ car.exteriorColor.description }}</span>
          </div> -->
        </div>
        <!-- TODO: Descomentar cuando lleguen datos KMs, potencia y consumo
        <div class="d-flex justify-content-between mb-2">
          <div class="d-flex flex-column w-100 gap-1">
            <span class="text-black fw-bold">{{ 'vinNumber' | i18next }}</span>
            <span class="text-muted">{{ car.VIN }}</span>
          </div>
          <div class="d-flex flex-column w-100 gap-1">
            <span class="text-black fw-bold text-uppercase">{{
              'requestPccTMAIMG' | i18next
            }}</span>
            <span class="text-muted">{{ car.tmaimg }}</span>
          </div>
          <div class="d-flex flex-column w-100 gap-1">
            <span class="text-black fw-bold">{{ 'kilometers' | i18next }}</span>
            <span class="text-muted">{{ car.kms | numberData }} KM</span>
          </div>
        </div> -->
      </div>
    </div>
  </div>

  <h5 *ngIf="car && car.optionals && car.optionals.length > 0">
    {{ 'equipment' | i18next }}
  </h5>
  <div
    *ngIf="car && car.optionals && car.optionals.length > 0"
    class="card"
    [style]="'flex-direction: column'"
  >
    <details>
      <summary>
        <span class="text-black">{{ 'details' | i18next }}</span>
      </summary>
      <ul class="my-4">
        <li *ngFor="let optional of car.optionals">
          <span class="text-muted">{{ optional.description }}</span>
        </li>
      </ul>
    </details>
  </div>

  <h5
    *ngIf="
      orderInfo?.campaignDataDTO &&
      orderInfo.campaignDataDTO?.type === campaignTypesEnum.RAFFLE
    "
  >
    {{ 'priorityList' | i18next }}
  </h5>
  <div
    class="card"
    *ngIf="
      orderInfo?.campaignDataDTO &&
      orderInfo.campaignDataDTO?.type === campaignTypesEnum.RAFFLE
    "
  >
    <div class="card-column d-flex flex-column">
      <div
        *ngFor="let item of carTitles; let i = index"
        class="item d-flex flex-column gap-1 mb-2"
      >
        <span class="text-black fw-bold">
          {{ i + 1 }}.
          {{ item.value !== null ? item.value : '-' }}
        </span>
      </div>
    </div>
  </div>

  <div *ngIf="orderInfo?.replacedVehicle">
    <h5>{{ 'stepReplaceVehicle' | i18next }}</h5>
    <div class="card">
      <div class="card--image">
        <img
          class="detail-leasing-request__img"
          [src]="
            orderInfo.replacedVehicle.image ||
            '../../../../assets/img/NeutroNaranjaRojo_v2.png'
          "
          alt="Imagen vehículo"
        />
      </div>
      <div class="d-flex flex-column gap-1" style="width: 100%">
        <div class="d-flex justify-content-between mb-2">
          <div class="d-flex flex-column gap-1">
            <span class="text-black text-uppercase lead fw-bold">{{
              orderInfo.replacedVehicle.model | valueData
            }}</span>
            <span class="text-black text-uppercase text-sm">{{
              orderInfo.replacedVehicle.plateNumber | valueData
            }}</span>
          </div>
        </div>
        <hr />
        <div class="d-grid gap-2 grid-container">
          <div
            class="d-flex flex-column gap-1 grid-item"
            [ngStyle]="
              orderInfo.replacedVehicle.exteriorColor
                ? { visibility: 'visible' }
                : { visibility: 'hidden' }
            "
          >
            <span class="text-black text-uppercase fw-bold">{{
              'color' | i18next
            }}</span>
            <span class="text-muted">{{
              orderInfo.replacedVehicle.exteriorColor?.description | valueData
            }}</span>
          </div>
          <div
            class="d-flex flex-column gap-1 grid-item"
            [ngStyle]="
              orderInfo.replacedVehicle.fuelType
                ? { visibility: 'visible' }
                : { visibility: 'hidden' }
            "
          >
            <span class="text-black text-uppercase fw-bold">{{
              'combustible' | i18next
            }}</span>
            <span class="text-muted">{{
              orderInfo.replacedVehicle.fuelType | valueData
            }}</span>
          </div>
          <div
            class="d-flex flex-column gap-1 grid-item"
            [ngStyle]="
              orderInfo.replacedVehicle.emissions
                ? { visibility: 'visible' }
                : { visibility: 'hidden' }
            "
          >
            <span class="text-black fw-bold text-uppercase">{{
              'estimatedEmissions' | i18next
            }}</span>
            <span class="text-muted"
              >{{ orderInfo.replacedVehicle.emissions | valueData }} g/km</span
            >
          </div>
          <div
            class="d-flex flex-column gap-1 grid-item"
            [ngStyle]="
              orderInfo.replacedVehicle.motor
                ? { visibility: 'visible' }
                : { visibility: 'hidden' }
            "
          >
            <span class="text-black fw-bold">{{
              'motorization' | i18next
            }}</span>
            <span class="text-muted">{{
              orderInfo.replacedVehicle.motor | valueData
            }}</span>
          </div>
        </div>
        <div class="d-grid gap-2 grid-container">
          <div
            class="d-flex flex-column gap-1 grid-item"
            [ngStyle]="
              orderInfo.replacedVehicle.transmission
                ? { visibility: 'visible' }
                : { visibility: 'hidden' }
            "
          >
            <span class="text-black fw-bold">{{ 'gearbox' | i18next }}</span>
            <span class="text-muted">{{
              orderInfo.replacedVehicle.transmission | valueData
            }}</span>
          </div>
          <div
            class="d-flex flex-column gap-1 grid-item"
            [ngStyle]="
              orderInfo.replacedVehicle.tmaimg
                ? { visibility: 'visible' }
                : { visibility: 'hidden' }
            "
          >
            <span class="text-black fw-bold text-uppercase">{{
              'requestPccTMAIMG' | i18next
            }}</span>
            <span class="text-muted">{{
              orderInfo.replacedVehicle.tmaimg | valueData
            }}</span>
          </div>
          <div
            class="d-flex flex-column gap-1 grid-item"
            [ngStyle]="
              orderInfo.replacedVehicle.VIN
                ? { visibility: 'visible' }
                : { visibility: 'hidden' }
            "
          >
            <span class="text-black fw-bold">{{ 'vinNumber' | i18next }}</span>
            <span class="text-muted">{{
              orderInfo.replacedVehicle.VIN | valueData
            }}</span>
          </div>
          <div
            class="d-flex flex-column gap-1 grid-item"
            [ngStyle]="
              orderInfo.replacedVehicle.estimatedKms
                ? { visibility: 'visible' }
                : { visibility: 'hidden' }
            "
          >
            <span class="text-black fw-bold">{{ 'kilometers' | i18next }}</span>
            <span class="text-muted"
              >{{ orderInfo.replacedVehicle.estimatedKms }} KM</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <h5>{{ 'generalData' | i18next }}</h5>
  <div class="card" [style]="'justify-content: space-between'">
    <div
      *ngIf="additionalInfo && additionalInfo.requestCarType"
      class="d-flex flex-column gap-1"
    >
      <span class="text-black fw-bold">{{ 'category' | i18next }}</span>
      <span class="text-muted">{{
        additionalInfo.requestCarType | i18next
      }}</span>
    </div>
    <div *ngIf="additionalInfo" class="d-flex flex-column gap-1">
      <span class="text-black fw-bold">{{ 'type' | i18next }}</span>
      <span *ngIf="additionalInfo.substitutionVin" class="text-muted">{{
        'subtypeSus' | i18next
      }}</span>
      <span *ngIf="!additionalInfo.substitutionVin" class="text-muted">{{
        'subtypeFirstAssign' | i18next
      }}</span>
    </div>
    <div
      class="d-flex flex-column gap-1"
      *ngIf="orderInfo?.requestType !== requestTypesEnum.leasing"
    >
      <span class="text-black fw-bold">{{ 'retribution' | i18next }}</span>
      <span class="text-muted">{{
        retributionTranslation(orderInfo?.retribution) | valueData: '-'
      }}</span>
    </div>
    <div
      *ngIf="car && !!car.prices && car.prices.fee !== null"
      class="d-flex flex-column gap-1"
    >
      <span class="text-black fw-bold">{{ 'requestFee' | i18next }}</span>
      <span class="text-muted">{{ car.prices.fee | numberData }}€</span>
    </div>
    <div
      *ngIf="
        orderInfo?.requestType === requestTypesEnum.leasing &&
        car &&
        !!car.prices &&
        car.prices.leasingRE !== null
      "
      class="d-flex flex-column gap-1"
    >
      <span class="text-black fw-bold">{{
        'leasingRetribution' | i18next
      }}</span>
      <span class="text-muted">{{ car.prices.leasingRE | numberData }}€</span>
    </div>
    <div
      class="d-flex flex-column gap-1"
      *ngIf="orderInfo?.requestType === requestTypesEnum.leasing"
    >
      <span class="text-black fw-bold">{{ 'totalFee' | i18next }}</span>
      <span class="text-muted">{{ calculateTotalFee(car) }}</span>
    </div>
    <div
      *ngIf="
        orderInfo?.requestType !== requestTypesEnum.leasing &&
        car &&
        car.prices &&
        car.prices.primaryRE &&
        orderInfo?.retribution === 'PRIMARY'
      "
      class="d-flex flex-column gap-1"
    >
      <span class="text-black fw-bold">{{
        'retributionPrimary' | i18next
      }}</span>
      <span class="text-muted">{{ car.prices.primaryRE | numberData }}€</span>
    </div>
    <div
      *ngIf="
        orderInfo?.requestType !== requestTypesEnum.leasing &&
        car &&
        car.prices &&
        car.prices.primaryEndowmentRE &&
        orderInfo?.retribution === 'PRIMARY_ENDOWMENT'
      "
      class="d-flex flex-column gap-1"
    >
      <span class="text-black fw-bold">{{
        'retributionEndowmentPrimary' | i18next
      }}</span>
      <span class="text-muted"
        >{{ car.prices.primaryEndowmentRE | numberData }}€</span
      >
    </div>
    <div
      *ngIf="
        orderInfo?.requestType !== requestTypesEnum.leasing &&
        car &&
        car.prices &&
        car.prices.secondaryRE &&
        orderInfo?.retribution === 'SECONDARY'
      "
      class="d-flex flex-column gap-1"
    >
      <span class="text-black fw-bold">{{
        'retributionSecondary' | i18next
      }}</span>
      <span class="text-muted">{{ car.prices.secondaryRE | numberData }}€</span>
    </div>
    <div
      *ngIf="
        orderInfo?.requestType !== requestTypesEnum.leasing &&
        car &&
        car.prices &&
        car.prices.secondaryEndowmentRE &&
        orderInfo?.retribution === 'SECONDARY_ENDOWMENT'
      "
      class="d-flex flex-column gap-1"
    >
      <span class="text-black fw-bold">{{
        'retributionEndowmentSecondary' | i18next
      }}</span>
      <span class="text-muted"
        >{{ car.prices.secondaryEndowmentRE | numberData }}€</span
      >
    </div>
    <div
      *ngIf="
        orderInfo?.requestType === requestTypesEnum.leasing &&
        orderInfo?.checkMartorell != null
      "
      class="d-flex flex-column gap-1"
    >
      <span class="text-black fw-bold">{{
        'deliveryLocationText' | i18next
      }}</span>
      <span class="text-muted">{{
        orderInfo?.checkMartorell ? ('btnYes' | i18next) : ('btnNo' | i18next)
      }}</span>
    </div>
  </div>

  <h5 *ngIf="orderInfo?.requestType === requestTypesEnum.leasing">
    {{ 'chargedDocuments' | i18next }}
  </h5>
  <div
    class="card card-table"
    *ngIf="orderInfo?.requestType === requestTypesEnum.leasing"
  >
    <table mat-table [dataSource]="dataSource" class="table">
      <!-- Columna Fecha de creación -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'creationDate' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.date ? element.date : ('noData' | i18next) }}
        </td>
      </ng-container>

      <!-- Columna Tipo Documento -->
      <ng-container matColumnDef="documentType">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'documentType' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.documentType | i18next }}
        </td>
      </ng-container>

      <!-- Columna Documento -->
      <ng-container matColumnDef="document">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'documentationTableDescription' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.document ? element.document : ('noData' | i18next) }}
        </td>
      </ng-container>

      <!-- Columna Estado -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'status' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.status ? element.status : ('noData' | i18next) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'requestListActions' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          <div [hidden]="element.spinner">
            <button
              class="actions"
              mat-button
              (click)="downloadDocument(element)"
              [disabled]="!element.document"
              matTooltip="{{ 'downloadTooltip' | i18next }}"
            >
              <mat-icon
                aria-hidden="false"
                aria-label="Download"
                fontIcon="file_download"
              ></mat-icon>
            </button>
            <button
              class="actions"
              mat-button
              (click)="uploadDocument(element)"
              [disabled]="element.status !== ('pendingUpload' | i18next)"
              matTooltip="{{ 'addDoc' | i18next }}"
            >
              <mat-icon
                aria-hidden="false"
                aria-label="Upload"
                fontIcon="file_upload"
              ></mat-icon>
            </button>
          </div>
          <div *ngIf="element.spinner">
            <div class="spinner-border spinner" role="status"></div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <h5 *ngIf="orderInfo?.requestType !== requestTypesEnum.leasing">
    {{ 'stepAddInfo' | i18next }}
  </h5>
  <div
    *ngIf="
      additionalInfo && orderInfo?.requestType !== requestTypesEnum.leasing
    "
    class="card"
    [style]="
      'flex-direction: column; justify-content: flex-start; align-items: flex-start;; gap: 1rem; margin-bottom: 20px'
    "
  >
    <div class="d-flex flex-row flex-wrap gap-3">
      <div class="d-flex flex-column gap-1" style="width: 200px">
        <span class="text-black fw-bold">{{
          'additionalEmail' | i18next
        }}</span>
        <span class="text-muted">{{
          orderInfo.contactInfo.email ? orderInfo.contactInfo.email : '-'
        }}</span>
      </div>
      <div class="d-flex flex-column gap-1" style="width: 200px">
        <span class="text-black fw-bold">{{
          'additionalPhone' | i18next
        }}</span>
        <span class="text-muted">{{
          orderInfo.contactInfo.phoneNumber
            ? orderInfo.contactInfo.phoneNumber
            : '-'
        }}</span>
      </div>
    </div>
    <div class="d-flex flex-column gap-1">
      <span class="text-black fw-bold">{{ 'observations' | i18next }}</span>
      <span class="text-muted">{{
        orderInfo.observations ? orderInfo.observations : '-'
      }}</span>
    </div>
    <div
      *ngIf="orderInfo?.checkMartorell != null"
      class="d-flex flex-column gap-1"
    >
      <span class="text-black fw-bold">{{
        'deliveryLocationText' | i18next
      }}</span>
      <span class="text-muted">{{
        orderInfo?.checkMartorell ? ('btnYes' | i18next) : ('btnNo' | i18next)
      }}</span>
    </div>
  </div>
</main>
